// R-audit-2026-08-30 P0-001: 平台所有者路由守卫
//
// 场景: /platform-admin 与 /test 路由原本用 RequireModule module="admin",
// org super_admin/admin 拿到 admin 模块后 URL 直跳可穿守卫。
// 改用本守卫只允许 isPlatformOwner。
//
// 用法: <PlatformOwnerOnly><PlatformAdmin /></PlatformOwnerOnly>
//   (在 RequireModule 之外,即必须先过 platform_owner 守卫才能进模块检查)
//
// R-audit-2026-09-27 race fix: 加 isLoading gate,
// 权限接口(/api/auth/permissions)未返回时不要立刻 redirect,
// 否则真正的 platform_owner 也会被闪一下推到 /dashboard。

import { Navigate } from 'react-router-dom'
import usePermissions from '../../hooks/usePermissions'

export default function PlatformOwnerOnly({ children }) {
  const { isPlatformOwner, isLoading } = usePermissions()
  if (isLoading) {
    return null
  }
  if (!isPlatformOwner) {
    return <Navigate to="/dashboard" replace />
  }
  return children
}
